import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  BulkAttachmentSupport,
  ChannelConfigStatus,
  EmailChannelView,
  SetBulkChannelRequest,
  SetPrimaryChannelRequest,
  UserEmailPreference,
} from '../models/email-channel.model';

@Injectable({ providedIn: 'root' })
export class EmailChannelApiService {
  private readonly base = `${environment.apiUrl}api/email-channels/mine`;

  constructor(private http: HttpClient) {}

  listMine(): Observable<EmailChannelView[]> {
    return this.http.get<EmailChannelView[]>(this.base);
  }

  setBulk(req: SetBulkChannelRequest): Observable<void> {
    return this.http.put<void>(`${this.base}/bulk`, req);
  }

  clearBulk(): Observable<void> {
    return this.http.delete<void>(`${this.base}/bulk`);
  }

  getMyPreference(): Observable<UserEmailPreference> {
    return this.http.get<UserEmailPreference>(`${this.base}/primary`);
  }

  setPrimary(req: SetPrimaryChannelRequest): Observable<UserEmailPreference> {
    return this.http.put<UserEmailPreference>(`${this.base}/primary`, req);
  }

  /**
   * GET /api/email-channels/mine/bulk-attachment-support — indica si el canal
   * bulk efectivo del usuario admite adjuntos (gate de la sección de adjuntos
   * en campañas cuando se usa el canal por defecto). businessId/userId del JWT.
   */
  getBulkAttachmentSupport(): Observable<BulkAttachmentSupport> {
    return this.http.get<BulkAttachmentSupport>(`${this.base}/bulk-attachment-support`);
  }

  /**
   * GET /api/email-channels/mine/config-status (Inc 21) — estado de configuración
   * de canales del usuario. Sirve para guiar al usuario y habilitar el canal
   * bulk SIN exigir un canal primario previo. userId/businessId del JWT.
   */
  getConfigStatus(): Observable<ChannelConfigStatus> {
    return this.http.get<ChannelConfigStatus>(`${this.base}/config-status`);
  }
}
